import { Component, Inject, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { MasterService } from "@frontend/app/serivces/master.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Cls_CompanyData } from "@frontend/app/models/master";
import { ToastrService } from "@frontend/app/serivces/app-toast.service";
import { SVG_ICONS } from "@frontend/app/models/icons";
import { DocumentUploadComponent } from "@frontend/app/components/document-upload/document-upload.component";

type DocumentObject = {
  Category: string;
  FileName: string;
  MimeType: string;
  Base64: string;
};
@Component({
  selector: "app-add-company",
  imports: [CommonModule, SharedModule, DocumentUploadComponent],
  templateUrl: "./add-company.component.html",
  styleUrl: "./add-company.component.scss",
})
export class AddCompanyComponent {
  private masterService = inject(MasterService);
  private toastrService = inject(ToastrService);
  private dialogRef = inject(MatDialogRef<AddCompanyComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) data: any) {
    if (data) {
      this.companyID = data.companyId;
      this.getCompanyDetailsByID();
    }
  }

  //#region variables
  companyID = 0;
  companyDetails = new Cls_CompanyData();
  readonly SVG_ICONS = SVG_ICONS;
  uploadedDocuments: { [key: string]: DocumentObject[] } = {
    Aadhar: [],
    MedicalCertificate: [],
    Profile: [],
  };
  //#endregion\

  getCompanyDetailsByID() {
    this.masterService.getCompanyDetailsByID(this.companyID).subscribe((res: any) => {
      this.companyDetails = res.data;


      // If company logo exists → push into uploadedDocuments.Profile
      if (this.companyDetails.CompanyLogo) {
        this.uploadedDocuments["Profile"] = [
          {
            Category: "Profile",
            FileName: this.extractFileName(this.companyDetails.CompanyLogo),
            MimeType: "image/jpeg", // or detect dynamically
            Base64: this.companyDetails.CompanyLogo, // sending URL directly → your component should display it
          },
        ];
      }
    });
  }

  extractFileName(url: string): string {
    return url.split("/").pop() || "profile.jpg";
  }

  onSubmit() {
    const tempModal = new Cls_CompanyData();
    tempModal.CompanyID = this.companyDetails.CompanyID || 0;
    tempModal.CompanyName = this.companyDetails.CompanyName;
    tempModal.CompanyType = this.companyDetails.CompanyType;
    tempModal.ContactNumber = this.companyDetails.ContactNumber;
    tempModal.City = this.companyDetails.City;
    tempModal.State = this.companyDetails.State;
    tempModal.Country = this.companyDetails.Country;
    tempModal.Address = this.companyDetails.Address;
    tempModal.PrimaryEmail = this.companyDetails.PrimaryEmail;
    tempModal.Website = this.companyDetails.Website;
    tempModal.CGST = this.companyDetails.CGST;
    tempModal.SGST = this.companyDetails.SGST;
    tempModal.PAN = this.companyDetails.PAN;
    tempModal.GSTIN = this.companyDetails.GSTIN;
    if (this.companyID == 0) {
      this.masterService.addCompany(tempModal).subscribe((res: any) => {
        this.toastrService.success("Company added successfully");
        this.dialogRef.close(res);
      });
    } else {
      this.masterService.updateCompany(tempModal, this.companyID).subscribe((res: any) => {
        this.toastrService.success("Company updated successfully");
        this.dialogRef.close(res);
      });
    }
  }

  updateDocuments(newDocs: DocumentObject[]): void {
    if (!newDocs || newDocs.length === 0) return;
    const category = newDocs[0].Category;
    if (category === "Profile") {
      this.uploadedDocuments[category] = [newDocs[0]];
    } else {
      if (!this.uploadedDocuments[category]) {
        this.uploadedDocuments[category] = [];
      }
      this.uploadedDocuments[category].push(...newDocs);
    }
  }

  removeFile(docToRemove: DocumentObject): void {
    const category = docToRemove.Category;
    if (this.uploadedDocuments[category]) {
      this.uploadedDocuments[category] = this.uploadedDocuments[category].filter(doc => doc.FileName !== docToRemove.FileName);
    }
  }

  onClose() {
    this.dialogRef.close();
  }
}
